// user------------------------
function updateUser(state) {
	return (user) => {
		Object.assign(state.user, user);
	}
}
function resetUserStore (state) {
	return (user) => {
		Object.keys(state.user).forEach((key) => {
			if(["admin","isValid"].some(e=>e == key)){
				state.user[key] = false;
			}else{
				state.user[key] = '';
			}
		})
		localStorage.setItem('userInfo',JSON.stringify('{}'));
	}
}
let userAction = (state)=>{
	return {
		updateUser: updateUser(state),
		resetUserStore: resetUserStore(state),
	}
}

// chater------------------------
function setChater(state){
	return (data)=>{
		Object.assign(state.chater, data);
	}
}
function clearChater(state){
	return (data)=>{
		Object.keys(state.chater).forEach(k=>{
			state.chater[k] = '';
		})
	}
}
let chaterAction = (state)=>{
	return {
		setChater: setChater(state),
		clearChater: clearChater(state),
	}
}
// ------------------------
function setGlobalBasic(state){
	return (info)=>{
		Object.keys(info).forEach(k=>{//目前此法更新数据只会更新到state下的第一层对象属性，如未来需要更新更深的对象属性可能需要另用递归实现；
			Object.assign(state[k],info[k]);
		})
	}
}
let setGlobalBasicAction = (state)=>{
	return {
		set: setGlobalBasic(state),
	}
}
// ------------------------

/**
 * 创建Action
 * @param state
 */
export function createAction(state) {
	return {
		user: userAction(state),
		chater: chaterAction(state),
		globalBasic: setGlobalBasicAction(state),
	}
}